import { render, staticRenderFns } from "./ReportTaggableListItem.vue?vue&type=template&id=c6f06342&"
import script from "./ReportTaggableListItem.vue?vue&type=script&lang=js&"
export * from "./ReportTaggableListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6f06342')) {
      api.createRecord('c6f06342', component.options)
    } else {
      api.reload('c6f06342', component.options)
    }
    module.hot.accept("./ReportTaggableListItem.vue?vue&type=template&id=c6f06342&", function () {
      api.rerender('c6f06342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/report/ReportTaggableList/ReportTaggableListItem.vue"
export default component.exports